import { RelationshipStatus } from '../models/enum/shared/relationship-status';

export class RelationshipStatusUtils {
  private static readonly PARTNERED_STATUSES = new Set<RelationshipStatus>([
    RelationshipStatus.Married,
    RelationshipStatus.CommonLaw
  ]);

  // Statuses that indicate the member currently has a spouse (e.g. eligible for joint annuity options).
  private static readonly SPOUSE_STATUSES = new Set<RelationshipStatus>([
    RelationshipStatus.Married,
    RelationshipStatus.CommonLaw,
    RelationshipStatus.Separated
  ]);

  static isPartneredStatus(status: RelationshipStatus | null): boolean {
    if (status === null) return false;
    return this.PARTNERED_STATUSES.has(status);
  }

  static hasSpouseStatus(status: RelationshipStatus | null): boolean {
    if (status === null) return false;
    return this.SPOUSE_STATUSES.has(status);
  }

  static getRelationshipStartDateLabel(typeId: RelationshipStatus | null): string {
    if (typeId === RelationshipStatus.CommonLaw) {
      return $localize`Relationship Cohabitation Date`;
    } else {
      return $localize`Relationship Effective Date`;
    }
  }
}
